import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ClientList.css';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import AuthContext from './AuthContext'; // Import the AuthContext
import { useContext } from 'react';


const apiClient = axios.create({
  baseURL: process.env.REACT_APP_PROXY_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const ClientList = () => {
  console.log('ClientList component mounted'); // troubleshooting

  const { customerId } = useParams();
  const { user, logout } = useContext(AuthContext); // Use the AuthContext
  const [clients, setClients] = useState([]);
  const [statusFilter, setStatusFilter] = useState('Active'); // Initialize as 'Active'
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

   const handleCreate = () => {

              const url = `/customer/${customerId}/client/manage/new`;
              //const newTab = window.open(url, '_self');
              navigate(`/customer/${customerId}/client/manage/new`);
          
            }

  // Fetch clients whenever statusFilter changes
  useEffect(() => {    
    // check expiration
    const currentTime = Date.now() / 1000; // in seconds
    if (user.exp && user.exp <= currentTime) {
         // token has expired
         navigate('/login');
    }
    console.log("User object:", user);
    if (user) {
      if (user.role_name === 'User') {
        setError('Access denied.');
        return;
      }
      fetchClients(statusFilter);
    } else {
      setError('User is not authenticated.');
    }
  }, [statusFilter, user]);

  const fetchClients = async (statusFilter) => {
    try {
      setIsLoading(true);
  
      if (!user || !localStorage.getItem('token')) {
        throw new Error('User is not authenticated or JWT token is missing.');
      }
  
      console.log('Fetching clients with status:', statusFilter);
  
      
      const payload = { 
        customer_id: String(user.customer_id),
        user_id: String(user.id )
      };
      const response = await apiClient.post(
        '/api/client/list',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );

  
      let data = response.data;
  
      console.log('Raw client data:', data);
  
      // Filter data based on role_name
      if (user.role_name === 'Admin') {
        data = data.filter((client) => {
          const activeValue = String(client.active ?? '').trim().toUpperCase();

          return (
            client.customer_number === user.customer_id &&
            (statusFilter === 'Active'
              ? activeValue === 'YES'
              : activeValue === 'NO')
          );
        });
      }

      if (user.role_name === 'SuperAdmin') {
        data = data.filter((client) => {
          const activeValue = String(client.active ?? '').trim().toUpperCase();

          return statusFilter === 'Active'
            ? activeValue === 'YES'
            : activeValue === 'NO';
        });
      }
  
      setClients(data);
      setIsLoading(false);
    } catch (error) {
        console.error('Error fetching clients:', error);
        if (!user || !localStorage.getItem('token')) {
            setError('User is not authenticated or JWT token is missing or expired. Please Log in again.');
        } else {
            setError('An error occurred while fetching clients.');
        }
        setIsLoading(false);
    }
};


  // Toggle between 'Active' and 'Inactive' status
  const toggleStatusFilter = () => {
    setStatusFilter((prevStatus) =>
      prevStatus === 'Active' ? 'Inactive' : 'Active'
    );
  };

  const handleViewDetails = (customerId) => {
    navigate(`/customer/${customerId}/client/manage`);
  };

  if (isLoading) { 
    if (error) {
      return <div className="error">{error}</div>;
    }
    else return <div>Loading Clients...</div>;
  }
  if (error) {
    return <div className="error">{error}</div>;
  }
  return (
    <div className="client-list-container">
      <h1>{statusFilter === 'Active' ? 'Active Clients' : 'Inactive Clients'}</h1>
      <button onClick={toggleStatusFilter} className="toggle-button">
        {statusFilter === 'Active' ? 'Show Inactive Clients' : 'Show Active Clients'}
      </button>
      <table className="client-table">
        <thead>
          <tr>
            <th>Customer ID</th>
            <th>Customer Name</th>
            <th>Homepage</th>
            <th>Limit Access</th>
            <th>Disabled</th>
            <th>Products</th>
            <th>TaxID Block</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {clients.map((client) => {
            // Process products if it's an array
            const productsDisplay = Array.isArray(client.products)
              ? client.products.join(', ')
              : client.products;

            // Determine if the client is disabled (opposite of 'active' status)
            const isDisabled = String(client.active ?? '').trim().toUpperCase() !== 'YES';
           
            return (
              <tr key={client.customer_number}>
                <td>{client.customer_number}</td>
                <td>{client.name}</td>
                <td>{client.homepage}</td>
                <td>{client.limit_access ? 'Yes' : 'No'}</td>
                <td>{isDisabled ? 'Yes' : 'No'}</td>
                <td>{productsDisplay}</td>
                <td>{client.taxid_block ? 'Yes' : 'No'}</td>
                <td>
                  <button
                    onClick={() => handleViewDetails(client.customer_number)}
                    className="client-detail-link"
                  >
                    View Details
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div>
        { (user?.role_name == "Admin" || user?.role_name == "SuperAdmin" ) ? (
          <button
            onClick={() => handleCreate()}
            className="customer-create-link"
            >
                  Create New Customer
          </button>
          ) : (
          <div></div>
          )}  </div>
    </div>
  );
};

export default ClientList;